import {useEffect, useRef} from 'react';

import {Box} from '@mui/material';
import PropTypes from 'prop-types';

import useEmmai from '../../../../../../../hooks/providers/useEmmai';
import {useScrollableArrows} from '../../hooks/useScrollableArrows/useScrollableArrows';
import ArrowButton from '../ArrowButton/ArrowButton';

const ScrollableRow = ({items, children}) => {
  const {selectedPractitionerId} = useEmmai();
  const scrollRef = useRef(null);
  const {showLeft, showRight, scrollLeft, scrollRight} = useScrollableArrows(scrollRef, [items]);

  useEffect(() => {
    if (!selectedPractitionerId) return;

    const container = scrollRef.current;
    const target = container?.querySelector(`[data-id="practitioner-${selectedPractitionerId}"]`);

    if (container && target) {
      target.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [selectedPractitionerId, items]);

  return (
    <Box display="flex" alignItems="center" maxWidth="100%">
      {showLeft && <ArrowButton direction="left" onClick={scrollLeft} />}

      <Box
        ref={scrollRef}
        sx={{
          overflowX: 'auto',
          display: 'flex',
          flexGrow: 1,
          '&::-webkit-scrollbar': {display: 'none'}
        }}
      >
        {children}
      </Box>

      {showRight && <ArrowButton direction="right" onClick={scrollRight} />}
    </Box>
  );
};

ScrollableRow.propTypes = {
  items: PropTypes.array,
  children: PropTypes.node
};

export default ScrollableRow;
